import {BaseEntityUnDeletable} from '../../../common/entities';

export class CallReason extends BaseEntityUnDeletable {
    description: string;
}
